/**
 * auth (인증) orval 래퍼
 *
 * orval 생성 함수를 기존 SDK 패턴(authApi.xxx)으로 래핑한다.
 * 기존 코드에서 import 경로만 바꾸면 되도록 동일한 인터페이스를 제공한다.
 *
 * NOTE: login은 Basic auth 헤더를 직접 구성해야 하므로 customInstance를 직접 사용한다.
 * NOTE: getAccessTokenFromRefresh는 setAccessToken 부수효과를 보존한다.
 */
import { get } from "../endpoints/인증/인증";
import { customInstance } from "../custom-instance";
import { setAccessToken } from "@erp/shared/utils/auth/token";
// orval이 생성한 factory에서 API 함수들을 꺼낸다
const generated = get();
// ── API 함수 ──
export async function login(id, password) {
    return customInstance({
        url: "/auth/login",
        method: "POST",
        headers: {
            Authorization: `Basic ${btoa(`${id}:${password}`)}`,
        },
    });
}
export async function logout() {
    return generated.authControllerLogout();
}
export async function getAccessTokenFromRefresh() {
    const newAccessToken = await generated.authControllerGetAccesTokenFromRefreshToken();
    if (!newAccessToken) {
        throw new Error("토큰이 발급되지 않았습니다.");
    }
    setAccessToken(newAccessToken);
    return newAccessToken;
}
export async function changePassword(oldPassword, newPassword) {
    const body = { oldPassword, newPassword };
    return generated.authControllerChangePassword(body);
}
export async function changeTmpPassword(userLoginId, temporaryPassword, newPassword) {
    const body = {
        userLoginId,
        temporaryPassword,
        newPassword,
    };
    return customInstance({
        url: "/auth/password/new-required",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: body,
    });
}
export async function forgotPasswordSendConfirmEmail(userId) {
    const body = { userId };
    await generated.authControllerForgotPasswordRequest(body);
    return { success: true };
}
export async function forgotPasswordResetPassWord(userId, newPassword, confirmCode) {
    const body = { userId, newPassword, confirmCode };
    await generated.authControllerForgotPasswordConfirm(body);
    return { success: true };
}
export async function resendInvitation(userId) {
    const body = { userId };
    await generated.authControllerResendInvitation(body);
    return { success: true };
}
// ── SDK 객체 ──
export const authApi = {
    login,
    logout,
    getAccessTokenFromRefresh,
    changePassword,
    changeTmpPassword,
    forgotPasswordSendConfirmEmail,
    forgotPasswordResetPassWord,
    resendInvitation,
};
